/**
 * Tour steps — Agents domain
 * Cubre: agents (clave), agent-health, agent-groups, certificates
 */

import {
  HardDrives as Server,
  Pulse,
  UsersFour,
  Certificate
} from '@phosphor-icons/react';

// ============ AGENTS (clave en quick) ============
const agentsProspect = {
  id: 'agents',
  title: 'Tus equipos protegidos',
  description: 'Aquí ves todos los equipos donde Vektor está protegiendo: estado en vivo, qué está pasando en cada uno y si alguno necesita atención. Sin polling manual.',
  icon: Server,
  position: 'right',
  highlight: '[data-testid="nav-agents"]',
  fallbackSelector: '[href="/agents"]',
  mode: 'prospect',
  length: 'both',
  domain: 'agents',
  videoFallback: null
};

const agentsOnboarding = {
  id: 'agents',
  title: 'Gestión de agentes',
  description: 'Inventario de agentes Windows/Linux con heartbeat, comandos en cola, dispatcher HTTP y self-update firmado. Soporta Atomic Red Team executor y compresión zstd en el canal agent↔backend.',
  icon: Server,
  position: 'right',
  highlight: '[data-testid="nav-agents"]',
  fallbackSelector: '[href="/agents"]',
  mode: 'onboarding',
  length: 'both',
  domain: 'agents',
  videoFallback: null
};

// ============ AGENT HEALTH (solo full) ============
const agentHealthProspect = {
  id: 'agent-health',
  title: 'Salud de los equipos',
  description: 'Identifica los equipos que llevan tiempo sin reportar, los que dan errores o los que necesitan actualización. Ahorra horas de troubleshooting manual.',
  icon: Pulse,
  position: 'right',
  highlight: '[data-testid="nav-agent-health"]',
  fallbackSelector: '[href="/agent-health"]',
  mode: 'prospect',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

const agentHealthOnboarding = {
  id: 'agent-health',
  title: 'Agent Health',
  description: 'Vista operativa de fleet: last_seen, version drift, errores de heartbeat, comandos pendientes. Filtra por estado para priorizar remediación.',
  icon: Pulse,
  position: 'right',
  highlight: '[data-testid="nav-agent-health"]',
  fallbackSelector: '[href="/agent-health"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

// ============ AGENT GROUPS (solo full) ============
const agentGroupsProspect = {
  id: 'agent-groups',
  title: 'Agrupa equipos por función',
  description: 'Organiza tus equipos por área (servidores, oficinas, producción) y aplica políticas distintas a cada grupo. Más control con menos esfuerzo.',
  icon: UsersFour,
  position: 'right',
  highlight: '[data-testid="nav-agent-groups"]',
  fallbackSelector: '[href="/agent-groups"]',
  mode: 'prospect',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

const agentGroupsOnboarding = {
  id: 'agent-groups',
  title: 'Agent Groups',
  description: 'Segmenta el fleet por grupos lógicos para targeting de Atomic tests, scope de Sigma rules y broadcast de comandos. Útil para entornos con miles de endpoints.',
  icon: UsersFour,
  position: 'right',
  highlight: '[data-testid="nav-agent-groups"]',
  fallbackSelector: '[href="/agent-groups"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

// ============ CERTIFICATES (solo full) ============
const certificatesProspect = {
  id: 'certificates',
  title: 'Conexión segura garantizada',
  description: 'Vektor cifra la comunicación con cada equipo usando certificados únicos. Si un equipo es robado, lo aíslas con un clic.',
  icon: Certificate,
  position: 'right',
  highlight: '[data-testid="nav-certificate-management"]',
  fallbackSelector: '[href="/certificate-management"]',
  mode: 'prospect',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

const certificatesOnboarding = {
  id: 'certificates',
  title: 'mTLS Certificate Management',
  description: 'CA bootstrap interno (/initialize), emisión per-agent, verificación de firma reforzada. Revoca certificados de agentes comprometidos sin tocar el resto del fleet.',
  icon: Certificate,
  position: 'right',
  highlight: '[data-testid="nav-certificate-management"]',
  fallbackSelector: '[href="/certificate-management"]',
  mode: 'onboarding',
  length: 'full',
  domain: 'agents',
  videoFallback: null
};

export const domainSteps = {
  prospect: {
    quick: [agentsProspect],
    full: [agentsProspect, agentHealthProspect, agentGroupsProspect, certificatesProspect]
  },
  onboarding: {
    quick: [agentsOnboarding],
    full: [agentsOnboarding, agentHealthOnboarding, agentGroupsOnboarding, certificatesOnboarding]
  }
};
